// extracted by mini-css-extract-plugin
export default {"container":"style_container__+bVTZ","video":"style_video__6pLn+","poster":"style_poster__copFK","headerContainer":"style_headerContainer__lPdPk","prices":"style_prices__RCCY4"};